export const translations = {
    en: {
        language: 'Language',
        english: 'En',
        vietnamese: 'Vi',
        familyTree: 'Family Tree',
        users: 'Users',
        logout: 'Logout',
        gender: 'Gender',
        birthday: 'Birthday',
        deathday: 'Deathday',
        position: 'Position',
        add: 'Add',
        addMember: 'Add Member',
        edit: 'Edit',
        editMember: 'Edit Profile',
        remove: 'Remove',
        saveSuccess: 'Save data successfully',
        saveError: 'Save data failed',
        dataNotFound: 'Data not found',
        male: 'Male',
        female: 'Female',
        saveAndClose: 'Save & Close',
        name: 'Name',
        imageUrl: 'Image URL',
        role: 'Role',
        sameGrade: 'Same Grade',
        spouse: 'Spouse',
        lowerGrade: 'Lower Grade',
        deadthday: 'Deathday',
        story: 'Story',
        note: 'Note',
        close: 'Close',
        wife: 'Wife',
        husband: 'Husband',
        sister: 'Sister',
        brother: 'Brother',
        father: 'Father',
        mother: 'Mother',
        son: 'Son',
        daughter: 'Daughter',
        grandson: 'Grandson',
        granddaughter: 'Granddaughter',
        uncle: 'Uncle',
        aunt: 'Aunt',
        search: 'Search... type ? to get help'
    },
    vi: {
        language: 'Ngôn ngữ',
        english: 'Tiếng Anh',
        vietnamese: 'Tiếng Việt',
        familyTree: 'Cây Gia Phả',
        users: 'Người dùng',
        logout: 'Đăng xuất',
        gender: 'Giới tính',
        birthday: 'Ngày sinh',
        deathday: 'Ngày mất',
        position: 'Vị trí',
        add: 'Thêm',
        addMember: 'Thêm thành viên',
        edit: 'Sửa',
        editMember: 'Cập nhật hồ sơ',
        remove: 'Xóa',
        saveSuccess: 'Lưu dữ liệu thành công',
        saveError: 'Lưu dữ liệu thất bại',
        dataNotFound: 'Không tìm thấy dữ liệu',
        male: 'Nam',
        female: 'Nữ',
        saveAndClose: 'Lưu & Đóng',
        name: 'Tên',
        imageUrl: 'URL ảnh',
        role: 'Vai trò',
        sameGrade: 'Cùng thế hệ',
        spouse: 'Vợ/Chồng',
        lowerGrade: 'Thế hệ sau',
        deadthday: 'Ngày mất',
        story: 'Câu chuyện',
        note: 'Ghi chú',
        close: 'Đóng',
        wife: 'Vợ',
        husband: 'Chồng',
        sister: 'Chị/Em gái',
        brother: 'Anh/Em trai',
        father: 'Cha',
        mother: 'Mẹ',
        son: 'Con trai',
        daughter: 'Con gái',
        grandson: 'Cháu trai',
        granddaughter: 'Cháu gái',
        uncle: 'Chú/Bác',
        aunt: 'Cô/Dì',
        search: 'Tìm kiếm... nhập ? để được trợ giúp'
    }
}; 